import request from '@/utils/request';
export function changeList(data) {
  return request.post('admin/audit/insurance-review/change-list', data);
}
export function changeDetail(data) {
  return request.post('admin/audit/insurance-review/changeDetail', data);
}
export function changeResult(data) {
  return request.post('admin/audit/insurance-review/result', data);
}